// extracted by mini-css-extract-plugin
export default {"DatePicker":"DatePicker_DatePicker__mZT3w"};